"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var context_1 = require("../context");
function useCurrentUser() {
    var app = react_1.useContext(context_1.default).app;
    if (app) {
        return app.auth().currentUser;
    }
    return null;
}
exports.default = useCurrentUser;
//# sourceMappingURL=useCurrentUser.js.map